import { css } from '@emotion/react';
import { theme } from '../../../theme';

const { primary, divider } = theme.palette;
const { md, sm } = theme.breakpoints;

const faqWrapper = css`
  margin: 0 auto 100px;
  width: 100%;
  max-width: 1167px;
  padding: 75px 0 0;

  & > h3 {
    text-align: center;
    color: ${primary.main};

    @media (max-width: ${`${md}px`}) {
      text-align: left;
    }
  }

  @media (max-width: ${`${md}px`}) {
    width: calc(100% - 50px);
    padding: 50px 0;
    margin: 0 auto 50px;
  }
`;

const borderBottomStyle = css`
  border-bottom: 1px solid ${divider};
`;

const collapseWrapper = css`
  & > div:nth-of-type(1) {
    border-top: none;
  }
`;

const collapseStyle = css`
  padding: 23px 0;

  & .MuiAccordionSummary-content {
    @media (max-width: ${`${md}px`}) {
      font-size: 16px;
      line-height: 21px;
      font-weight: 400;
    }
  }

  & .MuiAccordionDetails-root {
    font-size: 24px;
    line-height: 30px;
    font-weight: 200;

    @media (max-width: ${`${md}px`}) {
      font-size: 16px;
      line-height: 21px;
    }
  }

  @media (max-width: ${`${md}px`}) {
    padding: 0;
  }
`;

const additionalCollapseStyle = css`
  & * {
    border-top: none;
    border-bottom: none;
  }

  & .MuiAccordionDetails-root {
    @media (max-width: ${`${md}px`}) {
      padding: 0;
    }
  }

  & > .MuiAccordionSummary-root > .MuiAccordionSummary-content {
    font-size: 14px;
    line-height: 18px;
    text-decoration: underline;
  }
  &
    > .MuiCollapse-root
    > .MuiCollapse-wrapper
    > .MuiCollapse-wrapperInner
    > .MuiAccordion-region
    > .MuiAccordionDetails-root {
    padding: 0;
  }
`;

const additionalGroupStyle = css`
  padding: 15px 0;

  @media (max-width: ${`${md}px`}) {
    padding: 0;
    font-size: 16px;
    line-height: 21px;
  }
`;

const groupWrapper = css`
  width: 100%;
  font-size: 14px;
  line-height: 18px;
  font-weight: 300;
`;

const readMoreWrapper = css`
  width: 100%;
  text-decoration: underline;
  margin: 5px auto 0;
`;

const bodyColStyle = css`
  padding: 0 0 30px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 300;
  color: ${primary.main};
`;

const headerWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 35px;

  & h3 {
    @media (min-width: ${`${sm}px`}) {
      text-align: center;
    }
  }

  & span {
    @media (max-width: ${`${sm}px`}) {
      display: none;
    }
  }
`;

export {
  faqWrapper,
  collapseWrapper,
  collapseStyle,
  borderBottomStyle,
  additionalCollapseStyle,
  additionalGroupStyle,
  groupWrapper,
  readMoreWrapper,
  bodyColStyle,
  headerWrapper,
};
